import AnnouncementAdapter from './announcementAdapter';
import WaitMusicAdapter from './waitMusicAdapter';
export var AdapterTypes;
(function (AdapterTypes) {
    AdapterTypes[AdapterTypes["WaitMusic"] = 0] = "WaitMusic";
    AdapterTypes[AdapterTypes["Announcement"] = 1] = "Announcement";
})(AdapterTypes || (AdapterTypes = {}));
export const getAdapter = (adapterName) => {
    switch (adapterName) {
        case AdapterTypes.WaitMusic:
            return new WaitMusicAdapter();
        case AdapterTypes.Announcement:
            return new AnnouncementAdapter();
        default:
            throw new Error('Adapter not specified');
    }
};
